import request from '@/utils/request'


// 查询调查问卷选项列表
export function listSurveyAnswers(query) {
  return request({
    url: '/biz/survey-answers/list',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项分页
export function pageSurveyAnswers(query) {
  return request({
    url: '/biz/survey-answers/page',
    method: 'get',
    params: query
  })
}

// 查询调查问卷选项详细
export function getSurveyAnswers(data) {
  return request({
    url: '/biz/survey-answers/detail',
    method: 'get',
    params: data
  })
}

// 新增调查问卷选项
export function addSurveyAnswers(data) {
  return request({
    url: '/biz/survey-answers/add',
    method: 'post',
    data: data
  })
}

// 修改调查问卷选项
export function updateSurveyAnswers(data) {
  return request({
    url: '/biz/survey-answers/edit',
    method: 'post',
    data: data
  })
}

// 删除调查问卷选项
export function delSurveyAnswers(data) {
  return request({
    url: '/biz/survey-answers/delete',
    method: 'post',
    data: data
  })
}
